/** @format */

import { AccordionModule, ProgressSpinnerModule } from '@shared/components';
import { CommonModule } from '@angular/common';
import { HttpService } from '@shared/data-access/services';
import { Logger } from '@logger';
import { NgModule } from '@angular/core';
import { ReviewBVReviewsComponent } from './review-bv-reviews.component';
import { SeoService } from '@seo/data-access';

@NgModule({
	imports: [AccordionModule, CommonModule, ProgressSpinnerModule],
	declarations: [ReviewBVReviewsComponent],
	exports: [ReviewBVReviewsComponent],
	providers: [HttpService, Logger, SeoService]
})
export class ReviewBVReviewsModule {}
